/* ==========================================================================
   Sticky Add to Cart - JavaScript Handler
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('[data-sticky-atc]');
  if (!stickyBar) return;

  // Settings
  let cartRedirection = true;
  let rootPath = '/';
  const settingsEl = document.querySelector('[data-sticky-atc-settings]');
  if (settingsEl) {
    try {
      const parsed = JSON.parse(settingsEl.textContent);
      cartRedirection = parsed.cartRedirection !== false;
      rootPath = parsed.rootPath || '/';
    } catch (e) {}
  }

  // Elements inside Sticky Bar
  const variantSelect = stickyBar.querySelector('[data-sticky-atc-variant-select]');
  const priceDisplay = stickyBar.querySelector('[data-sticky-atc-price]');
  const comparePriceDisplay = stickyBar.querySelector('[data-sticky-atc-compare-price]');
  const qtyInput = stickyBar.querySelector('[data-sticky-atc-qty-input]');
  const qtyMinus = stickyBar.querySelector('[data-sticky-atc-qty-minus]');
  const qtyPlus = stickyBar.querySelector('[data-sticky-atc-qty-plus]');
  const submitBtn = stickyBar.querySelector('[data-sticky-atc-submit]');
  const btnText = stickyBar.querySelector('[data-sticky-atc-button-text]');
  const spinner = stickyBar.querySelector('[data-sticky-atc-spinner]');

  // Main Product Form Elements
  const mainForm = document.querySelector('form[action*="/cart/add"], [data-product-form]');
  const mainAtcBtn = document.querySelector('[data-product-atc], .product-form--atc-button, form[action*="/cart/add"] button[type="submit"]');
  const mainVariantInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
  const mainQtyInput = mainForm ? mainForm.querySelector('[name="quantity"]') : null;

  /* --------------------------------------------------------------------------
     1. Mobile & Desktop Visibility Controller
     -------------------------------------------------------------------------- */
  function updateVisibility() {
    if (!mainAtcBtn) return;
    const rect = mainAtcBtn.getBoundingClientRect();
    // Show sticky bar if main ATC button is scrolled above viewport or past view
    const isScrolledPast = rect.bottom < 50 || (window.pageYOffset > (mainAtcBtn.offsetTop + 100));

    if (isScrolledPast) {
      stickyBar.classList.add('sticky-atc--visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('sticky-atc--visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  if (mainAtcBtn) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            updateVisibility();
          } else {
            stickyBar.classList.remove('sticky-atc--visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, {
        threshold: 0
      });

      observer.observe(mainAtcBtn);
    }

    // Attach scroll and resize listeners for mobile reliability
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();
  }

  /* --------------------------------------------------------------------------
     2. Variant & Quantity Selection Controllers
     -------------------------------------------------------------------------- */
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const price = selectedOption.getAttribute('data-price');
      const comparePrice = selectedOption.getAttribute('data-compare-price');

      if (priceDisplay && price) {
        priceDisplay.innerHTML = price;
      }
      if (comparePriceDisplay) {
        if (comparePrice) {
          comparePriceDisplay.innerHTML = comparePrice;
          comparePriceDisplay.style.display = '';
        } else {
          comparePriceDisplay.style.display = 'none';
        }
      }

      // Sync with main form variant input
      if (mainVariantInput) {
        mainVariantInput.value = selectedOption.value;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Quantity controls
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        syncQuantity(qtyInput.value);
      }
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      let val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      syncQuantity(qtyInput.value);
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < 1) val = 1;
      qtyInput.value = val;
      syncQuantity(val);
    });
  }

  function syncQuantity(val) {
    if (mainQtyInput) {
      mainQtyInput.value = val;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* --------------------------------------------------------------------------
     3. Sticky ATC Submit Action
     -------------------------------------------------------------------------- */
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (submitBtn.hasAttribute('disabled')) return;

      // Show smooth loading state without layout shift
      submitBtn.classList.add('sticky-atc__button--loading');
      if (spinner) spinner.style.display = 'inline-flex';
      submitBtn.setAttribute('disabled', 'disabled');

      const variantId = variantSelect ? variantSelect.value : (mainVariantInput ? mainVariantInput.value : null);
      const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : (mainQtyInput ? parseInt(mainQtyInput.value, 10) || 1 : 1);

      if (!variantId || variantId === 'not-selected') {
        if (mainAtcBtn) mainAtcBtn.click();
        resetButtonState();
        return;
      }

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      }).then(function (response) {
        return response.json();
      }).then(function () {
        if (cartRedirection) {
          window.location.href = rootPath + 'cart';
        } else {
          if (mainAtcBtn) mainAtcBtn.click();
          resetButtonState();
        }
      }).catch(function () {
        if (mainAtcBtn) mainAtcBtn.click();
        resetButtonState();
      });

      function resetButtonState() {
        submitBtn.classList.remove('sticky-atc__button--loading');
        if (spinner) spinner.style.display = 'none';
        submitBtn.removeAttribute('disabled');
      }
    });
  }

  /* --------------------------------------------------------------------------
     4. Essential Upsell Handler (Hides Popup Banner & Dual Product Addition)
     -------------------------------------------------------------------------- */
  let isProcessingUpsell = false;
  document.addEventListener('click', function (e) {
    const upsellBtn = e.target.closest('[data-essential-upsell-element="add-to-cart-button"], .essential-upsell-add-to-cart, [class*="essential-upsell"] button');
    if (upsellBtn && !isProcessingUpsell) {
      isProcessingUpsell = true;
      document.body.classList.add('upsell-adding');

      // Immediately hide ATC banner
      const atcBanner = document.querySelector('.atc-banner--container, [data-atc-banner]');
      if (atcBanner) {
        atcBanner.style.setProperty('display', 'none', 'important');
      }

      const variantInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
      const qInput = mainForm ? mainForm.querySelector('[name="quantity"]') : null;
      const mainVariantId = variantInput ? variantInput.value : null;
      const mainQty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;

      if (mainVariantId && mainVariantId !== 'not-selected') {
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: mainVariantId, quantity: mainQty }]
          })
        }).then(function () {
          setTimeout(function () {
            window.location.href = rootPath + 'cart';
          }, 350);
        }).catch(function () {
          window.location.href = rootPath + 'cart';
        });
      } else {
        setTimeout(function () {
          window.location.href = rootPath + 'cart';
        }, 350);
      }
    }
  }, true);
});
